import { render } from "./TotalSalesForYearReportGrapics.vue?vue&type=template&id=238d95e2"
import script from "./TotalSalesForYearReportGrapics.vue?vue&type=script&lang=js"
export * from "./TotalSalesForYearReportGrapics.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Proyectos\\ERP ELECTRONICO\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__